import React, { useContext,useState, useEffect } from 'react'
import notecontext from '../context/notes/notecontext'
import { useLocation } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import { style } from '@mui/system';
import { app, database, storage } from './firebaseConfig'
import { collection, addDoc,getDoc, getDocs, doc, updateDoc, deleteDoc ,onSnapshot,query,where,setDoc} from "firebase/firestore";
import { async } from '@firebase/util';

const Dropdownuser = () => {
    const collectionRef = collection(database, 'users')
    const context = useContext(notecontext);
    const { user, getUserdetails } = context;
    const [imagesrc, setimagesrc] = useState("https://www.pngall.com/wp-content/uploads/5/User-Profile-PNG-Image.png")

    useEffect(() => {
        getImage();
        getUserdetails();
        getImage()
    }, [])

    const getImage=async()=>{
        const emailQuery=query(collectionRef,where("email","==",user.email))
        // const imguser=[];
        // onSnapshot(emailQuery,(data)=>{
        //     console.log(data.docs.map((item) => {
        //            return { ...item.data()};
        //     }));
        //   })
        const querySnapshot = await getDocs(emailQuery);
        querySnapshot.forEach(async(doc) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
            await setimagesrc(doc.data().imageURL)
          });
    }

    return (
        <div>
            <div className="btn-group">
                <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Welcome {user.name}
                </button>
                <ul className="dropdown-menu">
                    {user.image && <li><Avatar alt="Remy Sharp" src={`data:image/png;base64,${user.image.data}`} sx={{ width: 56, height: 56 }} style={{ "margin-left": "8vw" }} /></li>}
                    <li><Avatar alt="Remy Sharp" src={imagesrc} sx={{ width: 56, height: 56 }} style={{ "margin-left": "8vw" }} /></li>

                    <li><div className="dropdown-item" >ID: {user._id}</div></li>
                    <li><div className="dropdown-item" >Name: {user.name}</div></li>
                    <li><div className="dropdown-item">Email: {user.email}</div></li>
                    <li><div className="dropdown-item">Date Joined: {user.date}</div></li>
                </ul>
            </div>
        </div>
    )
}

export default Dropdownuser